import React from 'react'
import {useNavigate} from 'react-router-dom'
import {not, isEmpty, pickBy} from 'ramda'
import {useIntl} from 'react-intl'
import * as Api from 'lib/api'
import {useAuthentication} from 'components/providers/AuthenticationProvider'
import {ProductForm} from 'components/organisms/products'

export default function AddProductPage() {
  const navigate = useNavigate()
  const intl = useIntl()
  const {tenant} = useAuthentication()
  const [errorMessage, setErrorMessage] = React.useState(null)

  const handleSubmit = async (values) => {
    const isNotEmpty = (val) => not(isEmpty(val))
    const result = await Api.createTenantProduct(tenant.id, pickBy(isNotEmpty, values))
    result.matchWith({
      Ok: ({value}) => {
        navigate('/products/' + value.id)
      },
      Error: ({value}) => {
        setErrorMessage(value.message)
      },
    })
  }

  return (
    <ProductForm
      initialValues={{name: '', brand: '', quantity: ''}}
      onSubmit={handleSubmit}
      errorMessage={errorMessage}
      submitLabel={intl.formatMessage({id: 'products.new.submitButton'})}
      loadingText={intl.formatMessage({id: 'products.new.submitting'})}
      cancelTo="/products"
    />
  )
}
